import { Viewer } from '~/graphql/types'
import { PartialBy } from '~/types/Generics'

type RequiredFields =
  | 'knowYourCustomer'
  | 'locationCountryCode'
  | 'isPhoneVerified'
  | 'isEmailVerified'
  | 'createdAt'
  | 'cart'
  | 'selectedPayoutMethod'
  | 'consent'
export type UserIdentity = PartialBy<Viewer, RequiredFields>

const getIdentifyPayload = (user: UserIdentity | null) => {
  if (!user) return null

  const {
    knowYourCustomer,
    locationCountryCode: countryCode,
    isPhoneVerified,
    isEmailVerified,
    cart,
    createdAt,
    selectedPayoutMethod,
    consent,
  } = user

  const hasGivenMarketingEmailConsent = Boolean(
    consent?.find(consent => consent?.type === 'MARKETING_EMAIL' && consent?.hasGivenConsent)
  )
  const hasGivenMarketingPushConsent = Boolean(
    consent?.find(
      consent => consent?.type === 'MARKETING_PUSH_NOTIFICATION' && consent?.hasGivenConsent
    )
  )

  return {
    isPhoneVerified,
    isEmailVerified,
    kycStatus: knowYourCustomer?.status || null,
    hasPayoutMethodSetUp: Boolean(selectedPayoutMethod?.name),
    hasCartItems: Boolean(cart?.id),
    hasGivenMarketingEmailConsent,
    hasGivenMarketingPushConsent,
    createdAt,
    countryCode,
  }
}

export default getIdentifyPayload
